"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const helper_1 = require("../../../services/helper");
const SeatsPassengersDetail = ({ flightData }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    const { text, icon } = (0, helper_1.getSeatsPassengersDetailTextIcon)(flightData, t);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "detail", children: [(0, jsx_runtime_1.jsx)("img", { src: icon, alt: "" }), (0, jsx_runtime_1.jsx)("span", { className: "text-detail", children: text })] }));
};
exports.default = SeatsPassengersDetail;
